module.exports = __webpack_public_path__ + "img/about-icon-1.552d3208.png";